import {
  AISystemEntity,
  ComplianceStatus,
  RiskClassification,
} from '../../../types/AISystems.types';

export const entityOptions = [
  { value: AISystemEntity.PROVIDER, label: 'Provider' },
  { value: AISystemEntity.DEPLOYER, label: 'Deployer' },
  { value: AISystemEntity.DISTRIBUTOR, label: 'Distributor' },
  { value: AISystemEntity.IMPORTER, label: 'Importer' },
  { value: AISystemEntity.PRODUCT_MANUFACTURER, label: 'Product manufacturer' },
  {
    value: AISystemEntity.AUTHORISED_REPRESENTATIVE,
    label: 'Authorised representative',
  },
];

export const complianceStatusOptions = [
  { value: ComplianceStatus.INITIATED, label: 'Initiated' },
  { value: ComplianceStatus.CLASSIFYING, label: 'Classifying' },
  { value: ComplianceStatus.IN_PROGRESS, label: 'In Progress' },
  { value: ComplianceStatus.COMPLIANT, label: 'Compliant' },
  {
    value: ComplianceStatus.COMPLIANT_RISK_CLASSIFIED,
    label: 'Compliant (Risk-Classified)',
  },
  { value: ComplianceStatus.NON_COMPLIANT, label: 'Non-Compliant' },
  { value: ComplianceStatus.ATTENTION_REQUIRED, label: 'Attention Required' },
];

export const riskClassificationOptions = [
  { value: RiskClassification.MINIMAL_RISK, label: 'Minimal-Risk' },
  { value: RiskClassification.LIMITED_RISK, label: 'Limited-Risk' },
  { value: RiskClassification.HIGH_RISK, label: 'High-Risk' },
  { value: RiskClassification.PROHIBITED, label: 'Prohibited' },
  { value: RiskClassification.OTHER, label: 'Other' },
];
